<template>
  <div id="plans-launchpad">
    <Hero
      v-bind:title="$t('views.plans.title', {name: user.givenName})"
    >
      <h2>{{ $t("views.plans.header") }}</h2>
      <p>{{ $t("views.plans.text") }}</p>
      <TabNav v-bind:menu="tabMenu"/>
    </Hero>

    <router-view></router-view>
  </div>
</template>

<script>
import Hero from '@/components/plans/Hero.vue'
import TabNav from '@/components/TabNav.vue'

export default {
  name: 'Plans',
  components: {
    Hero,
    TabNav
  },
  data () {
    return {
      user: {},
      tabMenu: [
        {
          name: 'Plans',
          link: '/plans/'
        },
        {
          name: this.$t("views.plans.tab.archived"),
          link: '/plans/archive'
        }
      ],
    }
  },
  mounted: function () {
    // grab the user
    let user = JSON.parse(localStorage.getItem('user'))
    this.user = user.userInfo
  }
}
</script>

<style lang="scss">
.content-wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 70px;

  .welcome {
    margin-bottom: 60px;
  }
}
</style>
